import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { MessagingQueryKey } from '../../keys'
import { BrokeFlexMessageService } from '../services'
import { BrokeFlexMessageCampaignListResponse } from '../../types'

function useQueryGetBrokeFlexMessageCampaigns(
	isActive?: boolean,
	props?: UseBaseQueryOptions<BrokeFlexMessageCampaignListResponse>,
) {
	return useQuery({
		queryKey: [MessagingQueryKey.GetBrokeFlexMessageCampaigns, isActive],
		queryFn: () => BrokeFlexMessageService.getCampaigns(isActive),
		...props,
	})
}

export default useQueryGetBrokeFlexMessageCampaigns
